import React from "react";

const DoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="none" />
    <path d="M8 12l3 3 5-6" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const ActiveIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="active-pulse">
    <circle cx="12" cy="12" r="10" stroke="#5c4096" strokeWidth="2" fill="none" />
    <circle cx="12" cy="12" r="5" fill="#5c4096" />
  </svg>
);

const ProgressTracker = ({ steps, onStepClick }) => {
  const visible = steps.filter((step) => {
    const status = step.Status || step.status || "pending";
    const label = (step.Label || step.label || "").trim();
    return label.length > 0 && status !== "pending";
  });

  if (!visible.length) return null;

  return (
    <div className="nav-card progress-card">
      <div className="progress-title">Progress</div>
      <ul className="progress-list">
        {visible.map((step, i) => {
          const status = step.Status || step.status || "pending";
          const isDone = status === "done";

          return (
            <li
              key={i}
              className={`progress-item progress-item--${status} ${isDone ? "progress-item--clickable" : ""}`}
              onClick={() => isDone && onStepClick?.(i)}
              title={isDone ? "Click to go back" : ""}
            >
              {status === "done" ? <DoneIcon /> : <ActiveIcon />}
              <span className="progress-label">{step.Label || step.label}</span>
              {isDone && (
                <svg
                  className="back-arrow"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  stroke="#5c4096"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M8 3L4 7l4 4" />
                </svg>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProgressTracker;
